import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shoppingBag",
  "use": "shoppingBag-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 14 14\" id=\"shoppingBag\">\n\t<path d=\"M7 1c1.654 0 3 1.09 3 2v1H4V3c0-.91 1.346-2 3-2zM4 7c-.099-.071.153-.317 0-1 .153.38 0-1 0-1h6s-.153 1.38 0 1c-.153.683.098.929 0 1 .716-.071 1-.317 1-1V5h2v8H1V5h2v1c0 .683.283.929 1 1zm9-3c.436-.383-1.944-.395-2.002-.036C10.883 1.75 9.14 0 7 0 4.852 0 3.104 1.764 3 3.992 2.913 3.917.568 3.62 1 4 0 4 0 5 0 5v8c0 .75.247 1 1 1h12c.753 0 1-.25 1-1V5s0-1-1-1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol